import ListFeaturePage from '@/common/components/list-route/ListFeaturePage.tsx';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { getColumns } from '@/features/assets/columns.tsx';
import useAssetQueryFromAtom from '@/features/assets/hooks/useAssetQueryFromAtom.tsx';
import { AssetFilterBarMain } from '@/features/assets/components/AssetFilterBar.tsx';
import AssetPagination from '@/features/assets/components/AssetPagination.tsx';
import { ASSET_SORT_COLUMNS } from '@pac/filter/shared/assets';
import { assetSortAtom } from '@/features/assets/sorting.ts';

export const Route = createFileRoute('/assets/')({
  component: RouteComponent,
});

function RouteComponent() {
  const assetsQuery = useAssetQueryFromAtom();
  const columns = useMemo(() => getColumns(), []);

  return (
    <ListFeaturePage
      analyticsSurface="assets"
      storageKey="filter-aside:assets"
      query={assetsQuery}
      columns={columns}
      FilterBar={AssetFilterBarMain}
      Pagination={AssetPagination}
      sortColumns={ASSET_SORT_COLUMNS}
      sortAtom={assetSortAtom.sortAtom}
    />
  );
}
